/* eslint-disable */
class CartGiftWithPurchase {
  constructor() {
    this.modifiers = {
      containerHidden: "gift-with-purchase--hidden",
    };

    this.giftWithPurchaseMethods = {
      thresholds: "thresholds",
      itemSpecific: "item_specific",
    };

    this.giftWithPurchaseEnabled = GWP_GIFT_ENABLED;
    this.giftVariantId = GWP_GIFT_VARIANT_ID;
    this.giftWithPurchaseSelectedMethod = GWP_METHOD;
    this.priceThreshold = GWP_PRICE_THRESHOLD;
    this.excludedProducts = GWP_EXCLUDED_PRODUCTS ?? [];
    this.qualifyingProducts = GWP_QUALIFYING_PRODUCTS ?? [];
    this.enableConsoleDebugging = false;

    // this.logInitialValues();
  }

  logInitialValues() {
    console.log("this.giftVariantId", this.giftVariantId);
    console.log("this.giftWithPurchaseSelectedMethod", this.giftWithPurchaseSelectedMethod);
    console.log("this.qualifyingProducts", this.qualifyingProducts);
    console.log("this.excludedProducts", this.excludedProducts);
    console.log("this.priceThreshold", this.priceThreshold);
    console.log("this.enableConsoleDebugging", this.enableConsoleDebugging);
  }

  getGiftVariantId() {
    return this.giftVariantId;
  }

  checkIfGiftAlreadyAdded(cart) {
    const items = cart?.items ?? [];
    return items.some(
      (item) =>
        parseInt(item.variant_id) === parseInt(this.giftVariantId) &&
        item.properties?._isAutomaticGift === "true"
    );
  }

  checkGiftEligibility(cart) {
    if (!this.giftWithPurchaseEnabled) return false;

    switch (this.giftWithPurchaseSelectedMethod) {
      case this.giftWithPurchaseMethods.thresholds:
        this.debugLog("checkGiftEligibilityByThresholds");
        // Calculate the qualifying price including manually added GWP items
        const qualifyingPrice = cart?.items.reduce((total, item) => {
          if (
            !this.excludedProducts.includes(item.variant_id.toString()) &&
            !(
              this.giftVariantId === item.variant_id.toString() &&
              item.properties?._isAutomaticGift === "true"
            )
          ) {
            return total + parseInt(item.final_line_price);
          }
          return total;
        }, 0);
        this.debugLog("Qualifying price:", qualifyingPrice);
        return qualifyingPrice >= parseInt(this.priceThreshold);
      case this.giftWithPurchaseMethods.itemSpecific:
        this.debugLog("checkGiftEligibilityByItemSpecific");
		this.debugLog("qualifyingProducts", this.qualifyingProducts)
        const cartHasQualifyingProduct = cart?.items.some((item) =>
          this.qualifyingProducts.includes(item.variant_id.toString())
        );
        this.debugLog("cartHasQualifyingProduct", cartHasQualifyingProduct);
        return cartHasQualifyingProduct;
      default:
        this.debugLog("Invalid method");
        return false;
    }
  }

  async addGiftToCartAsFree(id) {
    // Add the GWP to the cart with a custom property indicating it was added automatically
    return this.updateCart("/cart/add.js", id, 1, { _isAutomaticGift: "true" });
  }

  async removeFreeGiftFromCart(cart) {
    // Find and remove the free GWP item with the "_isAutomaticGift" flag and zero line price
    const freeGift = cart.items.find(
      (item) =>
        parseInt(item.variant_id) === parseInt(this.giftVariantId) &&
        item.properties?._isAutomaticGift === "true"
    );

    if (freeGift) {
      await this.updateCart("/cart/change.js", freeGift.key, 0); // Use the unique key to remove the item
      this.debugLog(`Removed automatic free GWP item with key ${freeGift.key}`);
    } else {
      this.debugLog("No automatic free GWP item found to remove.");
    }
  }

  async updateCart(url, key, quantity, properties = {}) {
    if (!key) return false;

    this.debugLog(
      `Updating cart: URL = ${url}, Key = ${key}, Quantity = ${quantity}, Properties =`,
      properties
    );

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: key, quantity, properties }), // Use key as the id to change the specific line item
    });

    const data = await response.json();
    this.debugLog(`Response from updateCart:`, data);

    return data;
  }

  refreshCart() {
    const ajaxCart = document.querySelector("ajax-cart");
    if (ajaxCart) {
      this.refreshAjaxCart(ajaxCart);
    } else {
      this.refreshCartPage();
    }
  }

  refreshAjaxCart(ajaxCart) {
    this.debugLog("refreshAjaxCart");

    if (!ajaxCart) return false;

    const sections = ajaxCart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(",");

    fetch(`/?sections=${sections}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          ajaxCart.handleErrorMessage(response.description);
          return;
        }

        ajaxCart.getSectionsToRender().forEach((section) => {
          const currentSection = document.getElementById(section.id);
          if (currentSection) {
            currentSection.innerHTML = ajaxCart.getSectionInnerHTML(
              response[section.id],
              section.selector
            );
          }
        });

        ajaxCart.updateCartCount();
        ajaxCart.bindEvents();
      })
      .catch(console.error);
  }

  refreshCartPage() {
    this.debugLog("refreshCartPage");

    const cartItems = document.querySelector("cart-items");
    if (!cartItems) return;

    const sections = cartItems
      .getSectionsToRender()
      .map((section) => section.section)
      .join(",");

    fetch(`/?sections=${sections}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;

        cartItems.getSectionsToRender().forEach((section) => {
          const currentSection = document.getElementById(section.id);
          if (currentSection) {
            currentSection.innerHTML = cartItems.getSectionInnerHTML(
              response[section.section],
              section.selector
            );
          }
        });

        cartItems.updateCartCount();
      })
      .catch(console.error);
  }

  async manageGiftWithPurchase(cart) {
    this.debugLog("manageGiftWithPurchase");

    if (!cart) return false;

    const giftVariantId = this.getGiftVariantId();
    if (!giftVariantId) return false;

    const freeGiftLineFound = this.checkIfGiftAlreadyAdded(cart);
    const isEligibleForGift = this.checkGiftEligibility(cart);

    this.debugLog("freeGiftLineFound", freeGiftLineFound);
    this.debugLog("isEligibleForGift", isEligibleForGift);

    if (freeGiftLineFound && isEligibleForGift) {
      this.debugLog("Free gift already in cart and eligible.");
      return;
    }

    if (freeGiftLineFound && !isEligibleForGift) {
      this.debugLog("Free gift in cart but not eligible, removing.");
      await this.removeFreeGiftFromCart(cart); // Use the function to remove the specific free GWP item
      this.refreshCart();
      return;
    }

    if (!freeGiftLineFound && isEligibleForGift) {
      this.debugLog("Eligible for free gift, adding.");
      await this.addGiftToCartAsFree(giftVariantId);
      this.refreshCart();
    }
  }

  debugLog(...args) {
    if (this.enableConsoleDebugging) {
      console.log(...args);
    }
  }
}

window.CartGiftWithPurchase = new CartGiftWithPurchase();
